import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import { Link } from "gatsby"
import "twin.macro"
import Layout from "components/Layout"
import SeoHead from "components/SEO"
import Icon from "lib/Icon"
import Container from "components/Container"
import { paginationResolver } from "utils/paginationResolver"
import BlogPostFeed from "components/Blog/Feed"

import { withPrismicPreview } from "gatsby-plugin-prismic-previews"

const StyledContainer = styled(Container)`
  padding: 0 2rem;
`

const Header = styled.div`
  h4 {
    font-size: 2rem;
  }

  h3 {
    margin: 0;
    font-size: 3rem;
    color: ${(props) => props.theme.colors.primary};
    span {
      color: ${(props) => props.theme.colors.gray};
      opacity: 0.5;
    }
  }
`

function Feed({ data, ...props }) {
  if (!data) return null
  const { prismicSiteSettings } = data
  const { data: site_settings } = prismicSiteSettings

  const { prismicPage: page } = data
  const { nodes: pagePosts } = data.allPrismicBlogPost
  const { currentPage, numPages } = props.pageContext

  const { urlBase, isTagFeed } = paginationResolver(props.path)

  const featuredSlice = page.data.body.find(({ slice_type }) => {
    return slice_type === "featured_blog_posts"
  })

  return (
    <Layout site_settings={site_settings} lang={"da-dk"}>
      <StyledContainer>
        <Header>
          <Link to="/viden">
            <h4 tw="mt-8 mb-8">
              <Icon icon="long-arrow-left" />
              {` `}Viden forside
            </h4>
          </Link>
          {!isTagFeed ? (
            <h3>
              <span>Side {currentPage}</span>
            </h3>
          ) : (
            <h3>
              <span>Kategori: </span>#{decodeURI(urlBase.split("/")[1])}
              <span>{currentPage > 1 && `, side ${currentPage}`}</span>
            </h3>
          )}
        </Header>
        <BlogPostFeed
          items={pagePosts}
          currentPage={currentPage}
          numPages={numPages}
          featuredSlice={featuredSlice}
          isCategoryFeed
          {...props}
        />
      </StyledContainer>
    </Layout>
  )
}

export { Feed }
export default withPrismicPreview(Feed)

export const Head = ({ data, location, pageContext }) => {
  const { site, prismicSiteSettings, prismicPage: page } = data
  const { urlBase, isTagFeed } = paginationResolver(location.pathname)
  const currentPage = pageContext.currentPage || 1
  const tag = isTagFeed ? decodeURI(urlBase.split("/")[1]) : null
  const title = tag
    ? `#${tag} – Viden`
    : currentPage > 1
    ? `${page.data.meta_title} – Side ${currentPage}`
    : page.data.meta_title
  const description = tag
    ? `Artikler om ${tag} fra Clevertrack.`
    : page.data.meta_description

  return (
    <SeoHead
      siteMetadata={site.siteMetadata}
      siteSettings={prismicSiteSettings}
      lang={page.lang}
      slug={location.pathname}
      title={title}
      schemaTitle={title}
      description={description}
      images={page.data.meta_images}
      pageType="CollectionPage"
    />
  )
}

export const query = graphql`
  query Feed(
    $skip: Int!
    $limit: Int!
    $tags: [String] # $order: [SortOrderEnum]
  ) {
    site {
      ...SiteSeoMetadata
    }
    prismicSiteSettings {
      _previewable
      ...SiteNavigation
      ...FooterInformation
      ...FooterNavigation
      ...SocialMediaLinks
      ...UtilityNavigation
    }
    allPrismicBlogPost(
      sort: { fields: data___publication_date, order: DESC }
      limit: $limit
      skip: $skip
      filter: { tags: { in: $tags }, data: { public_publish: { eq: true } } }
    ) {
      nodes {
        ...BlogPostFragment
        ...BlogPostBodyFragment
      }
    }
    # harcoded for meta data
    prismicPage(lang: { eq: "da-dk" }, uid: { eq: "viden" }) {
      _previewable
      type
      lang
      uid
      ...FeaturedBlogposts
      data {
        meta_title
        meta_description
        meta_images {
          image {
            dimensions {
              width
              height
            }
            alt
            copyright
            url
            localFile {
              childImageSharp {
                id
                main: fixed(width: 1200) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
          }
        }
        show_in_sitemap
      }
    }
  }
`
